export const getEntityLabel = (entity, fallbackId, prefix = "Record") => {
  if (entity && typeof entity === "object") {
    return (
      entity.name ||
      entity.title ||
      entity.username ||
      entity.email ||
      entity.bill_no ||
      entity.stock_id ||
      entity.full_chassis ||
      (entity.id ? `${prefix} #${entity.id}` : null) ||
      "-"
    )
  }

  if (fallbackId || fallbackId === 0) {
    return `${prefix} #${fallbackId}`
  }

  return "-"
}

export const getUserLabel = value => {
  if (!value) {
    return "-"
  }

  if (typeof value === "object") {
    return value.name || value.username || value.email || (value.id ? `User #${value.id}` : "-")
  }

  return `User #${value}`
}

export const getReferenceLabel = (referenceType, referenceId) => {
  if (!referenceType && !(referenceId || referenceId === 0)) {
    return "No reference"
  }

  if (!referenceType) {
    return `Reference #${referenceId}`
  }

  if (referenceId || referenceId === 0) {
    return `${referenceType} #${referenceId}`
  }

  return referenceType
}
